import $ from "jquery";
import { validationRequired, validationRepeat } from "./util-validationForm";

const step = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-ChangeTab",
            buttonPrevRegister: ".js-PrevTab",
            details: ".js-DetailsTab",
            username: "#reg_username",
            email: "#reg_email",
            password: "#reg_password",
            passwordRepeat: "#reg_password_repeat",
            accountFirstName: "#account_first_name",
            accountLastName: "#account_last_name",
            billingPhoneField: "#billing_phone_field",
            billingCountry: "#billing_country",
            billingState: "#billing_state",
            billingPostcode: "#billing_postcode",
            billingAddress1Field: "#billing_address_1_field",
            stepper: ".Stepper",
            item: ".Stepper__Item",
            buttonSubmitWrapper:
                ".AccountPage__LoginRegister__Left__Form__ButtonRegister",
            buttonSubmit:
                ".AccountPage__LoginRegister__Left__Form__ButtonRegister button[name='register']",
        };

        if ($(el.details).length === 0) return;

        // prevent next if password strength not good or strong
        $(el.password).on("keydown keypress input focus blur", function () {
            const passwordStrength = $(el.password).siblings(
                ".woocommerce-password-strength",
            );
            // console.log(passwordStrength);

            if (
                passwordStrength.hasClass("bad") ||
                passwordStrength.hasClass("good") ||
                passwordStrength.hasClass("strong")
            ) {
                $(el.button).attr("disabled", false);
            } else {
                $(el.button).prop("disabled", "disabled");
            }
        });

        $(document).on("click", el.buttonSubmit, function (e) {
            const validationRequired_ = validationRequired($(this));
            if (!validationRequired_) {
                e.preventDefault();
            }
            $(this).trigger("submit");
            window.scrollTo(0, 0);
            $(".AccountPage__LoginRegister__Left").animate(
                { scrollTop: 0 },
                "slow",
            );
        });

        $(document).on("click", el.buttonPrevRegister, function (e) {
            e.preventDefault();
            const target = $(this).data("target");
            $(el.details).attr("open", false);

            const classStepper = `${el.stepper}--${$(this).data(
                "class-stepper",
            )}`;
            $(`${classStepper} ${el.item}`).removeClass("active");
            $(`${classStepper} ${el.item}--${target}`).toggleClass("active");
            $(`#section-${target}`).attr("open", true);

            // make previous stepper is done
            $(el.item + ".active")
                .prevAll(el.item)
                .addClass("done");
            $(el.item + ".active")
                .prevAll(el.item)
                .find(`${el.item}__Number`)
                .html(
                    `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10 3.5L4.85355 8.64645C4.65829 8.84171 4.34171 8.84171 4.14645 8.64645L2 6.5" stroke="black" stroke-width="1.5" stroke-linecap="round"/></svg>`,
                );

            if (target === "personal_detail") {
                $(el.buttonSubmitWrapper).show();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonPrevWrapper",
                ).show();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonNextWrapper",
                ).hide();
            } else {
                $(el.buttonSubmitWrapper).hide();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonPrevWrapper",
                ).hide();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonNextWrapper",
                ).show();
            }

            window.scrollTo(0, 0);
            $(".AccountPage__LoginRegister__Left").animate(
                { scrollTop: 0 },
                "slow",
            );
        });

        $(document).on("click", el.button, function (e) {
            e.preventDefault();
            const target = $(this).data("target");

            if (
                $(this).hasClass("SellTheCar__Button__Prev") ||
                $(this).hasClass(
                    "AccountPage__LoginRegister__Left__Form__ButtonPrev ",
                )
            ) {
                $(`span.js-error-message`).hide();
            } else {
                const validationRepeat_ = validationRepeat(
                    el.password,
                    el.passwordRepeat,
                    el.email,
                );
                const validationRequired_ = validationRequired($(this));
                if (!validationRequired_ || !validationRepeat_) return;
            }

            $(el.details).attr("open", false);

            const classStepper = `${el.stepper}--${$(this).data(
                "class-stepper",
            )}`;
            $(`${classStepper} ${el.item}`).removeClass("active");
            $(`${classStepper} ${el.item}--${target}`).toggleClass("active");
            $(`#section-${target}`).attr("open", true);

            // make previous stepper is done
            $(el.item + ".active")
                .prevAll(el.item)
                .addClass("done");
            $(el.item + ".active")
                .prevAll(el.item)
                .find(`${el.item}__Number`)
                .html(
                    `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M10 3.5L4.85355 8.64645C4.65829 8.84171 4.34171 8.84171 4.14645 8.64645L2 6.5" stroke="black" stroke-width="1.5" stroke-linecap="round"/></svg>`,
                );

            if (target === "personal_detail") {
                $(el.buttonSubmitWrapper).show();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonPrevWrapper",
                ).show();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonNextWrapper",
                ).hide();
            } else {
                $(el.buttonSubmitWrapper).hide();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonPrevWrapper",
                ).hide();
                $(
                    ".AccountPage__LoginRegister__Left__Form__ButtonNextWrapper",
                ).show();
            }

            // handle if press previous button
            if (
                $(this).hasClass("SellTheCar__Button__Prev") ||
                $(this).hasClass(
                    "AccountPage__LoginRegister__Left__Form__ButtonPrev",
                )
            ) {
                $(`${classStepper} ${el.item}--${target}`).removeClass("done");

                const index = $(`${classStepper} ${el.item}--${target}`).data(
                    "index",
                );

                $(`${classStepper} ${el.item}--${target}`)
                    .find(`${el.item}__Number`)
                    .html(index);
            }

            window.scrollTo(0, 0);
            $(".AccountPage__LoginRegister__Left").animate(
                { scrollTop: 0 },
                "slow",
            );
        });
    };

    init();
};

try {
    step();
} catch (error) {
    console.error("step: ", error);
}
